import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../patterns/Modal';

export interface SignOutConfirmProps {
  /** Number of scouting rounds not uploaded yet. */
  count: number;
  onConfirm: () => void;
  onCancel: () => void;
}

/** Warns that signing out leaves unsent scouting rounds on the phone. */
const SignOutConfirm: React.FC<SignOutConfirmProps> = ({ count, onConfirm, onCancel }) => {
  const { t } = useTranslation();
  return (
    <Modal show onHide={onCancel} title={t('signOut.unsentTitle')} size="sm">
      <Modal.Body>{t('signOut.unsentBody', { count })}</Modal.Body>
      <Modal.Footer>
        <button type="button" className="pat-btn pat-btn--subtle" onClick={onCancel}>
          {t('signOut.stay')}
        </button>
        <button type="button" className="pat-btn pat-btn--primary" onClick={onConfirm}>
          {t('signOut.anyway')}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default SignOutConfirm;
